import * as React from 'react';
import {Input as SemanticInput, Popup, TextArea} from "semantic-ui-react";
import {IVirtualizedTableCellComponentProps} from "../../VirtualizedTableInterfaces";

interface TextInputProps extends IVirtualizedTableCellComponentProps {
}

interface TextInputState {
    value: string | null;
}

export default class TextInput extends React.Component<TextInputProps, TextInputState> {
    constructor(props: TextInputProps) {
        super(props);

        this.state = {
            value: null
        };
    }

    componentDidMount() {
        this.setState({value: this.props.value});
    }

    componentDidUpdate(prevProps: TextInputProps, prevState: TextInputState) {
        if (this.props.value !== prevProps.value && this.state.value !== this.props.value)
            this.setState({value: this.props.value});
    }

    private saveChange = () => {
        if (this.props.value !== this.state.value)
            this.props.onChange(this.state.value);
    }

    private renderInputWithPopUp() {
        return (
            <Popup
                openOnTriggerClick={true}
                closeOnDocumentClick={true}
                onClose={this.saveChange}
                trigger={
                    <SemanticInput
                        value={this.state.value ? this.state.value : ""}
                        fluid={true}
                        onChange={(e) => this.setState({value: e.currentTarget.value})}
                        disabled={this.props.readOnly}
                    />
                }
                content={<TextArea
                    value={this.state.value ? this.state.value : ""}
                    onChange={(e) => this.setState({value: e.currentTarget.value})}
                    disabled={this.props.readOnly}
                />}
            />
        );
    }

    private renderInputOnly() {
        return (
            <SemanticInput
                value={this.state.value ? this.state.value : ""}
                fluid={true}
                onChange={(e) => this.setState({value: e.currentTarget.value})}
                disabled={this.props.readOnly}
                onBlur={this.saveChange}
            />);
    }
    public render() {
        if (this.props.inputWithPopup)
            return this.renderInputWithPopUp();
        return this.renderInputOnly();
    }

}



// WEBPACK FOOTER //
// ./src/components/Table/components/basic/TextInput.tsx